export default __webpack_public_path__ + "static/media/glaciallakes.958b3cfc.png";